import { render } from "./record.vue?vue&type=template&id=59e37e00&scoped=true&ts=true"
import script from "./record.vue?vue&type=script&lang=ts"
export * from "./record.vue?vue&type=script&lang=ts"

import "./record.vue?vue&type=style&index=0&id=59e37e00&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e37e00"]])

export default __exports__